export const EXTENSION_MESSAGE_TYPES = {
  LOGIN_WITH_CUSTOM_TOKEN: 'login-with-custom-token',
  UPDATE_FLAGS_CONFIG_FROM_WEB: 'bs_web_updateFlagsConfigFromWeb',
  UPDATE_CONFIG_FROM_WEB: 'bs_web_updateConfig',
  SYNC_CONFIG_TRIGGERED_FROM_WEB: 'bs_web_getSyncedConfigAndSaveToStorage',
  GET_CONFIG: 'GetConfig',
  GET_USER: 'bs_web_get_user',
  GET_USER_ID_TOKEN: 'bs_get_user_id_token',
  LOGOUT: 'logout',
  PURCHASED: 'purchased',

  // customize block page
  UPLOAD_BACKGROUND_FROM_WEB: 'bs_web_uploadBackground',
  DELETE_BACKGROUND_FROM_WEB: 'bs_web_deleteBackground',
} as const;

export const EXTENSION_STORAGE_KEYS = {
  IS_PREMIUM: 'isPremium',
} as const;
